module.exports = __webpack_public_path__ + "img/kenyan_flag.d6b14260.png";